import { DragEvent, FC } from 'react';

import { StyledDragHandle } from './BatchFormNavLayer.styles';

interface DragHandleProps {
  isDisplayed: boolean;
  onDragStart: (event: DragEvent<HTMLDivElement>) => void;
}

export const DragHandle: FC<DragHandleProps> = ({ isDisplayed, onDragStart }) => {
  if (!isDisplayed) {
    return null;
  }

  return (
    <StyledDragHandle
      className="bg-primary rounded-full position-absolute bottom-0 end-0 d-block cursor-cell"
      data-e2e="drag-handle"
      draggable={true}
      onDragStart={onDragStart}
    />
  );
};
